import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Map, OrderedMap, List } from 'immutable'
import ItemPrice from '@aytm/app/swidget/questions/components/sh/price'

import shelfStyle from '@aytm/app/swidget/questions/styles/sh/shelf.module.scss'

import { SETTINGS } from '@aytm/app/swidget/questions/components/sh/settings'

TopShelf.propTypes = {
  questionSchema: PropTypes.instanceOf(Map).isRequired,
  width: PropTypes.number.isRequired,
  mobile: PropTypes.bool.isRequired,
  prices: PropTypes.bool,
  widthFactor: PropTypes.number.isRequired,
  shelf: PropTypes.instanceOf(List).isRequired,
  answers: PropTypes.instanceOf(OrderedMap).isRequired
}

export function TopShelf(props) {
  const { questionSchema, width, widthFactor, answers, shelf, prices } = props
  const settings = {
    ...questionSchema.get('shelf_config').toJS(),
    ...SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')]
  }

  return (
    <div
      className={`${shelfStyle.shelf} ${shelfStyle.shelf0} ${shelfStyle[settings.styleClass]}`}
      style={{
        minHeight: settings.topShelf.height * widthFactor + settings.buttonWidth,
        width: width - settings.walls + 1
      }}
      data-testid="SW-SH-Shelf"
    >
      <div className={shelfStyle.dotsShelf} />
      <div className={shelfStyle.gradientShelf} />
      <div className={`${shelfStyle.bottomShelf} ${shelfStyle.topItem}`} />
      {prices && !questionSchema.get('hide_price') && (
        <div className={shelfStyle.layer}>
          {Array.apply(null, Array(shelf.size)).map((_, packIndex) => {
            const answer = answers.get(shelf.getIn([packIndex, 0])).set('firstIndex', 1)

            const itemsCount = shelf.getIn([packIndex, 1])

            return (
              <div
                className={shelfStyle.items}
                key={'pack' + packIndex}
                style={{ width: answer.get('width') * itemsCount }}
              >
                <ItemPrice item={answer} questionSchema={questionSchema} type={settings.priceTemplate} />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default memo(
  TopShelf,
  (prevProps, nextProps) =>
    prevProps.questionSchema === nextProps.questionSchema &&
    prevProps.width === nextProps.width &&
    prevProps.widthFactor === nextProps.widthFactor &&
    prevProps.answers === nextProps.answers &&
    prevProps.mobile === nextProps.mobile &&
    prevProps.answersIndex === nextProps.answersIndex
)
